import { Container, Row } from 'hui';
import React from 'react';
import { HeaderContextProvider } from '../HeaderContext';
import { MIN_WIDTH_DESKTOP, MIN_WIDTH_HOMEPAGE_DESKTOP } from './constants';
import HeaderLeft from './left/index';
import HeaderRight from './right/index';

export type HeaderProps = {
  siteSource: string;
  hasSearch?: boolean;
  shouldShowActions?: boolean;
  loginData: any;
  PartnerComponent: React.ReactElement;
};

const Header: React.FC<HeaderProps> = ({
  siteSource,
  hasSearch = false,
  loginData,
  children,
  shouldShowActions = true,
  // this prop is to be cleaned up if no future partnerships arise post-block
  PartnerComponent,
}) => {
  const breakPoint = hasSearch ? MIN_WIDTH_DESKTOP : MIN_WIDTH_HOMEPAGE_DESKTOP;
  /* eslint-disable react/forbid-component-props */
  return (
    <HeaderContextProvider
      hasSearch={hasSearch}
      siteSource={siteSource}
      loginData={loginData}
      breakPoint={breakPoint}
      shouldShowActions={shouldShowActions}
    >
      <Container fluid style={{ background: '#fff' }}>
        {hasSearch && children}
        <Row flexDirection={'row'} gutter={0} style={{ position: 'relative' }}>
          <HeaderLeft PartnerComponent={PartnerComponent} />
          <HeaderRight />
        </Row>
      </Container>
    </HeaderContextProvider>
  );
};

export default Header;
